import axios from 'axios';
import { APP_CONSTANTS } from '@/app/config/constants';
import { env } from '@/app/config/env';

/**
 * The single Axios instance for the whole app -- never create another.
 *
 * This module deliberately does NOT import ./interceptors. The interceptors
 * need the Redux store, the store runs rootSaga at module scope, and the sagas
 * reach back here through the services -- importing them would close that
 * cycle and leave `store` undefined at registration time. main.tsx wires them
 * up instead, via setupInterceptors(apiClient, store).
 */
export const apiClient = axios.create({
  baseURL: env.API_BASE_URL,
  timeout: APP_CONSTANTS.API_TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
  /*
    Repeat the key for an array parameter -- `filter=a&filter=b`, not axios's
    default `filter[]=a&filter[]=b`. Spring binds a repeated key to a
    `List<String>` parameter and does not recognise the bracketed form, so the
    default silently delivers an empty list: the masters' filter conditions
    would reach the server as no filter at all and the table would show every
    row as though the filter had been applied.
  */
  paramsSerializer: {
    indexes: null,
  },
});
